/**
 * Parse Hash
 */
export const parseHash = (hash) => {
	if (!hash) {
		return false;
	}

	hash = hash.substring(1);
	const obj = {};
	const qa = hash.split('&');

	for (let i = 0; i < qa.length; i++) {
		const [prop, value] = qa[i].split('=');
		obj[prop] = isNaN(value) ? decodeURIComponent(value) : parseFloat(value);
	}

	return obj;
};

/**
 * Escape HTML
 */
export const escapeHTML = (str) => {
	if (!str) return '';

	return str.replace(/[&<>"'/]/g, function (match) {
		switch (match) {
			case '&':
				return '&amp;';
			case '<':
				return '&lt;';
			case '>':
				return '&gt;';
			case '"':
				return '&quot;';
			case "'":
				return '&#39;';
			case '/':
				return '&#x2F;';
			default:
				return match;
		}
	});
};

/**
 * Get URL Parameter
 */
export const getUrlParameter = (sParam) => {
	const sPageURLOriginal = window.location.search.substring(1);
	const sPageURL = sPageURLOriginal.replace('%20&%20', '!_!');
	const sURLVariables = sPageURL.split('&');

	for (let i = 0; i < sURLVariables.length; i++) {
		const sURLVariablesFinal = sURLVariables[i].replace('!_!', ' & ');
		const sParameterName = sURLVariablesFinal.split('=');

		if (sParameterName[0] === sParam) {
			return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}

	return false;
};

/**
 * Get the appropriate video embed url based on the video type
 */
export const getVideoEmbedSrc = (videoId, videoType) => {
	let url = '';

	switch (videoType) {
		case 'youtube':
			url = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
			break;
		case 'vimeo':
			url = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
			break;
		case 'vidyard':
			url = `https://play.vidyard.com/${videoId}?autoplay=1&disable_popouts=1&disable_analytics=0&preload=auto&disable_larger_player=false&controller=hubs&action=show&type=inline&v=4.3.13`;
			break;
		case 'wistia':
			url = `https://fast.wistia.net/embed/iframe/${videoId}?autoplay=1&seo=false&videoFoam=true`;
			break;
		default:
			return ''; // Return empty string or handle unrecognized video types
	}

	return escapeHTML(url);
};

/**
 * Strip html
 */
export const stripHtml = html => {
	const doc = new DOMParser().parseFromString(html, 'text/html');
	return doc.body.textContent || "";
};

/**
 * Decode HTML entities
 */
export function decodeHTMLEntities(text) {
	const parser= new DOMParser();
	const doc = parser.parseFromString(text, "text/html");
	return doc.documentElement.textContent;
}

/**
 * Truncate to string
 */
export const truncateString = (str, num) => {
	if (str.length > num) {
		return str.slice(0, num) + "...";
	}
	return str;
};

/**
 * Create css variables
 */
export const createCssVariables = (cssVars) => {
	return cssVars.reduce((styles, cssVar) => {
		if (cssVar.value != null) {
			styles[cssVar.varName] = cssVar.value;
		}
		return styles;
	}, {});
};

/**
 * Validate URL
 */
export const isValidUrl = (string) => {
	try {
		new URL(string);
		return true;
	} catch (_) {
		return false;
	}
}
